export const STATUSES = {
  APPLIED: "Applied",
  BOUND: "Bound",
  CANCELLED: "Cancelled",
  DECLINED_EXPIRED: "Declined Expired",
  DECLINED: "Declined",
  DRAFT: "Draft",
  ERROR: "Error",
  EXPIRED: "Expired",
  IDLE: "Idle",
  IN_PROGRESS: "In progress",
  INFORCE: "Inforce",
  QUOTED: "Quoted",
  REFERRED_QUOTED: "Referred Quoted",
  REFERRED: "Referred",
  REJECTED_NOT_PROGRESSED: "Not Progressed",
  REJECTED_NOT_TAKEN_UP: "Not Taken Up",
  WARNING: "Warning",
};

export default STATUSES;
